export default function SvgPlay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="4rem"
      viewBox="0 -960 960 960"
      width="4rem"
      fill="none"
      className="play-icon"
    >
      <path d="M360-273.28v-415.39l326.15 207.7L360-273.28Z" />
    </svg>
  );
}
